import React from 'react'
import Helmet from 'react-helmet'

const VendorScripts = () => (
  <Helmet>
    <script>
      {`(function (p, l, o, w, i, n, g) {
      if (!p[i]) {
        p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || [];
        p.GlobalSnowplowNamespace.push(i);

        p[i] = function () {
          (p[i].q = p[i].q || []).push(arguments);
        };

        p[i].q = p[i].q || [];
        n = l.createElement(o);
        g = l.getElementsByTagName(o)[0];
        n.async = 1;
        n.src = w;
        g.parentNode.insertBefore(n, g);
      }

      // TODO: Move config to inside the build
      var realtimeConfig = {
        appId: 'shaadireact',
        cookieDomain: '.shaadi.com',
        respectDoNotTrack: true,
        forceSecureTracker: true,
      };
      var batchConfig = {
        cookieDomain: '.shaadi.com',
        forceSecureTracker: true,
        contexts: {
          webPage: true,
          performanceTiming: true,
        },
      };
      window.da('newTracker', 'production-realtime', 'tracking.shaadi.com', realtimeConfig);
      // TODO: Stg to prod
      window.da('newTracker', 'production-batch-client', 'tracking.shaadi.com', realtimeConfig); // Uses realtime config to push events to kafka
      window.da('newTracker', 'production-batch', 'tracking.shaadi.com', batchConfig);
    })(window, document, 'script', 'https://img2.shaadi.com/assests/2016/js/da-2-8-2.js', 'da');
    `}
    </script>
  </Helmet>
)

export default VendorScripts
